module.exports = __webpack_public_path__ + "img/arrow-dropdown.6c828ae1.svg";